var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",staticStyle:{"min-height":"450px"}},[_c('h6',{staticClass:"card-header text-primary"},[_vm._v(" Enroll State")]),_c('div',{staticClass:"card-body px-3"},[_vm._v(" Hello ")])])
}]

export { render, staticRenderFns }